module.exports = __webpack_public_path__ + "img/icon-calendar.a4a44531.svg";